import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'grecoMap' })
export class GrecoMapPipe implements PipeTransform {
  transform<T, U>(value: T[], map: (item: T) => U): U[] {
    return value ? (Array.isArray(value) ? value : [value]).map(item => map(item)) : [];
  }
}
